var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebookRounded(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2169_2258)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.5 10.0558C0.5 15.0275 4.11083 19.1617 8.83333 20V12.7775H6.33333V10H8.83333V7.7775C8.83333 5.2775 10.4442 3.88917 12.7225 3.88917C13.4442 3.88917 14.2225 4 14.9442 4.11083V6.66667H13.6667C12.4442 6.66667 12.1667 7.2775 12.1667 8.05583V10H14.8333L14.3892 12.7775H12.1667V20C16.8892 19.1617 20.5 15.0283 20.5 10.0558C20.5 4.525 16 0 10.5 0C5 0 0.5 4.525 0.5 10.0558Z",
    fill: "#586B94"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2169_2258"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookRounded);
export default __webpack_public_path__ + "static/media/facebook_rounded.bac9da9ab6578a1280981181d88acb90.svg";
export { ForwardRef as ReactComponent };